export function button() {
    const buttons = document.querySelectorAll('[data-btn]');
    if (!buttons.length) return;

    buttons.forEach((element) => {
        const textElement = element.querySelector('[data-btn-text]');
        const widthHover = Number(element.getAttribute('data-btn-width-hover')) || 0;
        const heightHover = Number(element.getAttribute('data-btn-height-hover')) || 0;

        if (!textElement) return;

        const setScale = (x, y) => {
            element.style.setProperty('--btn-scale-x', x);
            element.style.setProperty('--btn-scale-y', y);
        };

        const updateScale = () => {
            const currentWidth = element.offsetWidth;
            const currentHeight = element.offsetHeight;

            const scaleX = (currentWidth + widthHover) / currentWidth;
            const scaleY = (currentHeight + heightHover) / currentHeight;

            setScale(scaleX, scaleY);
        };

        updateScale();

        const text = textElement.textContent;
        textElement.innerHTML = '';

        [...text].forEach((char, index) => {
            const span = document.createElement('span');

            span.textContent = char;
            span.style.setProperty('--index', index);

            if (char === ' ') {
                span.style.whiteSpace = 'pre';
            }

            textElement.appendChild(span);
        });
    });
}
